import { createContext, useContext, useState } from "react";

const LeadModalContext = createContext(null);

export const useLeadModal = () => useContext(LeadModalContext);

export const LeadModalProvider = ({ children }) => {
  const [state, setState] = useState({ isOpen: false, type: "assessment", title: null });
  const open = (options = {}) => setState({ isOpen: true, type: options.type || "assessment", title: options.title || null });
  const close = () => setState((s) => ({ ...s, isOpen: false }));
  return (
    <LeadModalContext.Provider value={{ ...state, open, close }}>
      {children}
    </LeadModalContext.Provider>
  );
};
